
import ArrowIcon from '~/assets/images/arrow-icon.svg?inline'
import componentInstanceId from '~/mixins/component-instance-id'
import expandDirective from '~/directives/expand'

export default {
  components: {
    ArrowIcon,
  },
  directives: {
    expand: expandDirective,
  },
  mixins: [componentInstanceId('collapsible')],
  props: {
    label: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: false,
    },
    disableBreakpoint: {
      type: String,
      default: null,
    },
  },

  computed: {
    toggleProps() {
      return {
        role: 'button',
        tabindex: '0',
        'aria-expanded': this.open ? 'true' : 'false',
        'aria-controls': `${this.$id}-content`,
      }
    },

    toggleEvents() {
      return {
        click: this.onToggleClick,
      }
    },

    disableClass() {
      return this.disableBreakpoint
        ? `w-collapsible--disable--${this.disableBreakpoint}`
        : ''
    },
  },

  methods: {
    onToggleClick() {
      this.$emit('toggle')
    },
  },
}
